import {
    useScenariosInCluster,
    useSubscriptionForCluster
} from "in_queue/contexts/ProjectDataContext";

// This hook must be rendered within the ProjectDataContext
export const useIsAtScenarioLimit = (): boolean => {
    const subscription = useSubscriptionForCluster();
    const scenariosInCluster = useScenariosInCluster();

    if (!subscription || subscription === "loading") {
        return false;
    }

    return scenariosInCluster.length >= subscription.scenarioLimit;
};

/**
 * How many more scenarios this subscription allows, or `undefined` while the
 * count is still loading or when no subscription bounds it.
 *
 */
export const useRemainingScenarioSlots = (): number | undefined => {
    const subscription = useSubscriptionForCluster();
    const scenariosInCluster = useScenariosInCluster();

    if (
        !subscription ||
        subscription === "loading" ||
        scenariosInCluster === "loading"
    ) {
        return undefined;
    }
    return Math.max(0, subscription.scenarioLimit - scenariosInCluster.length);
};
